import styled, { css } from 'styled-components';
import { fontBody } from 'Styles/fonts';

export const Backdrop = styled.div`
  background-color: var(--background);
  width: calc(100% - 18px);
  height: 20px;
  top: 1px;
  left: 1px;
  position: absolute;
  border-top-left-radius: 3px;
  pointer-events: none;

  ${({ disabled }) =>
    disabled &&
    css`
      display: none;
    `}

  ${({ isFocused, hasError }) =>
    (isFocused || hasError) &&
    css`
      top: 2px;
      left: 2px;
    `}
`;

export const Label = styled.label`
  position: absolute;
  top: 0;
  left: 0;
  transform: translate(12px, 11px) scale(1);
  transform-origin: top left;
  transition: transform 300ms cubic-bezier(0.25, 1, 0.25, 1);
  cursor: text;
  user-select: none;
  color: var(--muted-foreground);
  ${fontBody(16)};

  ${({ isFocused, isEmpty }) =>
    (!isEmpty || isFocused) &&
    css`
      transform: translate(12px, 4px) scale(0.75);
    `}
`;

export default {};
